var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppLogoFlash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.02 310",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.99,
    y: 90,
    width: 122,
    height: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.87,209H37.11c-5,0-9.12-88.88-9.12-88.88A9.12,9.12,0,0,1,37.11,111h89.76a9.12,9.12,0,0,1,9.12,9.12S131.9,209,126.87,209Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141,117h0a22,22,0,0,1,22,22v39.16a8.84,8.84,0,0,1-8.84,8.84H141a0,0,0,0,1,0,0V117a0,0,0,0,1,0,0Z",
    transform: "translate(12.16 -11.25) rotate(4.42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23,117h0a0,0,0,0,1,0,0v70a0,0,0,0,1,0,0H9.44A8.45,8.45,0,0,1,1,178.55V139a22,22,0,0,1,22-22Z",
    transform: "translate(-11.13 1.29) rotate(-4.21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79,289H35a225.51,225.51,0,0,0,9-35.65A223.05,223.05,0,0,0,47,213H79Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86,289h44a223.39,223.39,0,0,1-12-76H86Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.54,32.35C128.93,13.81,107.54,0,82,0S35,13.82,29.42,32.38A33.29,33.29,0,0,0,28,42V84H136V42A33.51,33.51,0,0,0,134.54,32.35Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32,294H79a0,0,0,0,1,0,0v16a0,0,0,0,1,0,0H20a0,0,0,0,1,0,0v-4A12,12,0,0,1,32,294Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86,294h59a0,0,0,0,1,0,0v16a0,0,0,0,1,0,0H98a12,12,0,0,1-12-12v-4A0,0,0,0,1,86,294Z",
    transform: "translate(230.97 604) rotate(-180)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 66.49,
    cy: 56.5,
    r: 13,
    style: {
      fill: "#fcff35"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.49,
    cy: 55.5,
    r: 13,
    style: {
      fill: "#fcff35"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.99,
    y1: 42,
    x2: 98.49,
    y2: 69.5,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.49,
    y1: 55.5,
    x2: 111.49,
    y2: 55.5,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.49,
    y1: 56.5,
    x2: 79.49,
    y2: 56.5,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.84,205.54a9.49,9.49,0,1,0-13.22-.49L17,198.69Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M152.84,205.54a9.49,9.49,0,1,0-13.22-.49l6.37-6.36Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogoFlash);
export default __webpack_public_path__ + "static/media/app-logo-flash.6b1c585c70f62c27a957424ddd65c57d.svg";
export { ForwardRef as ReactComponent };